import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { WebApiService } from '../service/web-api.service';
import { environment } from '../../environments/environment';

@Injectable()
export class DocumentService {

  constructor(private webApiServece: WebApiService) { }

  /**
   * 未読書面情報取得
   */
  execAuthGetUnreadDocument(): Observable<any> {
    const requestParam = {};
    return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/get-unread-document', requestParam)
      .map(cfResponse => {
        return cfResponse.data;
      })
      .catch(error => {
        return Observable.throw(error);
      });
  }

  /**
   * 既読情報登録
   */
  execAuthRegisterReadDocument(documenetInfoList: any[]): Observable<any> {

    if (documenetInfoList == null) {
      return null;
    }

    // 登録する書面IDリスト作成
    let documenetIdList = '';
    for (const documentInfo of documenetInfoList) {
      documenetIdList += documentInfo.documentId + ',';
    }
    documenetIdList = documenetIdList.substr(0, documenetIdList.length - 1);

    const requestParam = { 'documenet_id_list' : documenetIdList };
    return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/register-read-document', requestParam)
      .map(cfResponse => {
        const data = cfResponse.data;
        // NGの場合はメッセージ、正常の場合はnullを返却
        if (!data.result) {
          return data.messages;
        }
        return null;
      })
      .catch(error => {
        return Observable.throw(error);
      });
  }
}
